(() => {
  const TRYON_TEXT = "- TRY ON"; // matches your product naming

  function isTryonProductForm(form) {
    // Most reliable: your PDP already uses product-rerender[data-tryon="true"]
    if (form.closest('product-rerender[data-tryon="true"]')) return true;

    // Fallback: title check if data-tryon isn't present
    const titleEl =
      document.querySelector(".product-title") ||
      document.querySelector('[data-product-title]') ||
      document.querySelector("h1");
    const title = (titleEl?.textContent || "").toLowerCase();
    return title.includes(TRYON_TEXT.toLowerCase());
  }

  async function addToCartAjax(form) {
    const fd = new FormData(form);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
      credentials: "same-origin",
    });

    if (!res.ok) {
      let msg = "Could not add to cart.";
      try {
        const err = await res.json();
        msg = err?.description || err?.message || msg;
      } catch (_) {}
      throw new Error(msg);
    }

    // Return added item
    return res.json();
  }

  async function refreshCartState() {
    // Pull latest cart so counters/drawers can update
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await res.json();

    // These events are commonly used by themes/apps
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

    return cart;
  }

  function toast(message) {
    // Safe basic toast; won't conflict with theme
    const el = document.createElement("div");
    el.textContent = message;
    el.setAttribute(
      "style",
      [
        "position:fixed",
        "right:16px",
        "bottom:16px",
        "z-index:99999",
        "padding:12px 14px",
        "background:#111",
        "color:#fff",
        "border-radius:12px",
        "font-size:14px",
        "max-width:280px",
        "box-shadow:0 8px 24px rgba(0,0,0,.18)",
      ].join(";")
    );
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 2200);
  }

  // Capture submit BEFORE theme handlers (important)
  document.addEventListener(
    "submit",
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      // Only intercept product forms
      if (!form.matches('form[action^="/cart/add"]')) return;

      // Only for Try-On products
      if (!isTryonProductForm(form)) return;

      // Stop the theme redirect logic
      e.preventDefault();
      e.stopImmediatePropagation();

      // Prevent double submits
      const btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (btn) btn.setAttribute("aria-busy", "true");

      try {
        await addToCartAjax(form);
        await refreshCartState();
        toast("Added to cart (Try-On).");
        // Stay on page: no redirect
      } catch (err) {
        console.error(err);
        toast(err?.message || "Could not add to cart.");
      } finally {
        if (btn) btn.removeAttribute("aria-busy");
      }
    },
    true // <-- capture is the key
  );
})();